import { ContainerProgressCircle } from "components/waste-icons/svgs/ContainerProgressCircle";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DateDisplay from "components/datetime/DateDisplay";

import { IconBatteryColoured, IconTemperatureColoured, IconFillingColoured } from "site-apps/assets/AssetColorsIcons";

const ContainerIconValues = ({ item }) => {
    const [_Tc] = useTranslation("choices");
    return (
        <div className="row justify-content-center">
            <div className="col measures pt-4">
                <div>
                    <IconFillingColoured value={item.filling} />
                </div>
                <div>
                    <IconBatteryColoured value={item.battery} />
                </div>
                <div>
                    <IconTemperatureColoured value={item.temperature} />
                </div>
            </div>
            <div className="col svg-filling p-0 text-center">
                <div className="text-center no-decoration text-black">{_Tc("wastes." + item.waste_type)}</div>
                <Link to={`/asset-management/containers/?uid=${item.uid}`} className="text-no-decoration" title="Ver contenedor">
                    <ContainerProgressCircle percent={item.filling} type={item.waste_type} />
                </Link>
            </div>
            <div className="col icons pt-4">
                {item.has_device ? (
                    item.uuids.map((uuid, uidx) => (
                        <div className="icon" key={uidx}>
                            <Link to={`/asset-management/devices/?uuid=${uuid}`}>
                                <FontAwesomeIcon icon="wifi" title="Ver dispositivo" className="text-success" />
                            </Link>
                        </div>
                    ))
                ) : (
                    <></>
                )}
                {item.has_route ? (
                    <div className="icon">
                        <FontAwesomeIcon icon="truck-fast" title="Tiene Ruta" className="text-blue" />
                    </div>
                ) : (
                    <></>
                )}
                {item.has_alerts ? (
                    <div className="icon">
                        <Link to={`/alerts/alerts/?uid=${item.uid}`}>
                            <FontAwesomeIcon icon="triangle-exclamation" className="text-warning" title="Tiene Alertas" />
                        </Link>
                    </div>
                ) : (
                    <></>
                )}
            </div>
            <div className="col-12 pt-2 date">
                <Link to={`/data-view/data-container/${item.uid}`} className="text-no-decoration" title="Ver datos">
                    <div className="text-center no-decoration text-black small">
                        <DateDisplay date={item.measured_at} title={true} />
                    </div>
                </Link>
            </div>
        </div>
    );
};
export default ContainerIconValues;
